import * as React from 'react';
const CrampiMuscolariIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M64.92 86.64c8.47 10.01 19.34 17.42 31.74 21.72"
      className="prefix__cls-2"
    />
    <path
      d="M96.66 108.35a63.18 63.18 0 0 0 5.01 36.74M93.32 54.9c15.66 15.09 35.95 29.28 38.42 38.42 3.34 12.39 3.34 51.78 3.34 51.78M108.35 96.52c.07 1.77.71 3.48 1.81 4.87"
      className="prefix__cls-2"
    />
    <path
      d="M120.18 111.41c1.56.57 3.26.67 4.87.28"
      className="prefix__cls-2"
    />
    <path
      d="m64.92 113.7 10.03 7.13 2.27-7.44 10.02 7.13M67.11 142.84l12.26-.85-2.96-7.19 12.27-.85"
      className="prefix__cls-1"
    />
  </svg>
);
export default CrampiMuscolariIcon;
